import React from "react";

const CaseStudy: React.FC = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <div className="space-y-5">
            <div className="inline-block bg-[#f2e9dd] text-[#5a4333] rounded-full px-4 py-2">
              <span className="text-sm font-semibold tracking-wider">
                Case study
              </span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light leading-tight text-[#2f2117]">
              We help strategy teams <br />
              test ideas <span className="text-[#9b8778]">rapidly.</span>
            </h2>

            <p className="text-base text-[#5c5147] leading-relaxed">
              A growth team at Hamilton wanted to test a new customer onboarding
              automation idea but couldn't get engineering bandwidth for months.
            </p>

            <p className="text-base text-[#5c5147] leading-relaxed">
              We worked directly with their strategy team, built the system in 10
              days, and launched it so they could start testing immediately.
            </p>

            <p className="text-base text-[#5c5147] leading-relaxed">
              Within 2 weeks, they validated the idea and scaled what worked.
            </p>

            {/* Results */}
            <div className="grid sm:grid-cols-2 gap-4 pt-4">
              <div className="bg-[#eee5d8] rounded-2xl p-6 text-[#2f2117]">
                <div className="text-3xl sm:text-4xl font-light mb-2">
                  10 days
                </div>
                <div className="text-sm font-semibold mb-1">
                  To first test
                </div>
                <div className="text-sm text-[#6f5c4f]">From idea to validation</div>
              </div>

              <div className="bg-[#eee5d8] rounded-2xl p-6 text-[#2f2117]">
                <div className="text-3xl sm:text-4xl font-light mb-2">
                  3x faster
                </div>
                <div className="text-sm font-semibold mb-1">
                  Testing speed
                </div>
                <div className="text-sm text-[#6f5c4f]">Than internal build cycles</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative hidden sm:block">
            <div className="rounded-3xl aspect-square max-w-lg w-full mx-auto relative overflow-hidden flex items-center justify-center bg-gradient-to-br from-lime-300 via-amber-200 to-emerald-400 shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
              <div className="absolute inset-0 bg-white/15 mix-blend-screen" />
              <div className="absolute inset-0 bg-gradient-to-tr from-white/20 via-transparent to-white/10" />
              <div className="hidden sm:flex absolute top-6 right-6 bg-white/90 text-gray-800 text-sm font-semibold px-4 py-2 rounded-full shadow-sm">
                Ecommerce
              </div>
              <div className="relative z-10 text-white text-5xl md:text-6xl font-light drop-shadow-md flex items-center gap-2">
                ✱
                <span>Hamilton</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;
